import * as Common from '@/tenant/common';

export class StockBalanceReportQuery extends Common.ReportQuery {
    constructor(){
        super("StockBalanceReportQuery", null);
    }
    public salesPurchaseFlag: number;
    public segment: Common.Segment = null;
    public warehouse: Common.Counterpart = null;
    public commodityCategory: number = null;
    public closingDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class StockBalanceReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='StockBalanceReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
